import React from 'react';
import PropTypes from 'prop-types';
import { Card } from '@salesforce/design-system-react';
import SlideGeneration from '../App/SlideGeneration';
import StageMapGeneration from '../App/StageMapGeneration';
import QuipGeneration from '../App/QuipGeneration';

const FinishModal = (props) => {
  return (
    <Card hasNoHeader>
      <div class="slds-p-horizontal_large">
          <QuipGeneration
            onSave={props.generateQuip}
            error={props.error}
            isLoading={props.isLoading}
            quipToken={props.quipToken}
            onQuipChange={props.onQuipChange}
            addToast={props.addToast}
          />
          {props.isCollaborator ? null : (
            <div className="slds-m-top_small">
              <SlideGeneration
                journeyId={props.journeyId}
                journeyEmail={props.journeyEmail}
                addToast={props.addToast}
                isSlidesLoading={props.isSlidesLoading}
                setSlidesLoading={props.setSlidesLoading}
                createSlides={props.createSlides}    
              />
            </div>
          )}
      </div>
    </Card>
  );
};

FinishModal.propTypes = {
  quipToken: PropTypes.string.isRequired,
  error: PropTypes.string,
  onQuipChange: PropTypes.func.isRequired,
  generateQuip: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  journeyEmail: PropTypes.string,
  addToast: PropTypes.func.isRequired,
  isSlidesLoading: PropTypes.bool.isRequired,
  setSlidesLoading: PropTypes.func.isRequired,
  createSlides: PropTypes.func.isRequired,
  isStageMapLoading: PropTypes.bool.isRequired,
  setStageMapLoading: PropTypes.func.isRequired,
  createStageMap: PropTypes.func.isRequired,
};

export default FinishModal;
